export const SEND_LEADSQUARED_INFO = "SEND_LEADSQUARED_INFO";
export const SAVE_LEADSQUARED_INFO = "SAVE_LEADSQUARED_INFO";
export const GET_LEADSQUARED_INFO = "GET_LEADSQUARED_INFO";

// export const SEND_LSQ_WHATSAPP_CONNECTOR = "SEND_LSQ_WHATSAPP_CONNECTOR";
export const SAVE_LSQ_WHATSAPP_CONNECTOR = "SAVE_LSQ_WHATSAPP_CONNECTOR";
export const GET_LSQ_WHATSAPP_CONNECTOR = "GET_LSQ_WHATSAPP_CONNECTOR";

export const SEND_HUBSPOT_INFO = "SEND_HUBSPOT_INFO";
export const SAVE_HUBSPOT_INFO = "SAVE_HUBSPOT_INFO";
export const GET_HUBSPOT_INFO = "GET_HUBSPOT_INFO";

export const SAVE_ZOHOCRM_INFO = "SAVE_ZOHOCRM_INFO";
export const GET_ZOHOCRM_INFO = "GET_ZOHOCRM_INFO";

export const SAVE_GOOGLESHEETS_INFO = "SAVE_GOOGLESHEETS_INFO";
export const GET_GOOGLESHEETS_INFO = "GET_GOOGLESHEETS_INFO";


export const SAVE_ZOHO_DESK_INFO = "SAVE_ZOHO_DESK_INFO";
export const GET_ZOHO_DESK_INFO = "GET_ZOHO_DESK_INFO";